import React, { Component } from 'react';
//import { Input } from 'reactstrap';
import { Form } from 'reactstrap';
import { Label } from 'reactstrap';
import { Button } from 'reactstrap';
import Details from '../Details/Details';
//import Register from '../Register/Register';
import withNavigateHook from '../../myRoutes';
//import { useLocation } from 'react-router-dom';
import axios from 'axios';
//import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class Registrations extends React.Component {
    constructor(props) {
        super(props);
        this.handleDetailsOpen = React.createRef()
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        this.state = {
            email: "",
            gender: "",
            memberGender: "",
            firstname: "",
            lastname: "",
            db: "",
            memberDob: "",
            membersCount: "",
            date: today,
            dateofbirth: new Date(),
            membersData: [],
            memberdetails: [],
            memberId: "",
            memberName: "",
            memberSurname: "",
            userRole: "",
            memberCity: "",
            memberCountry: "",
            register: "",
            details: "",
            dataId: "",
            memberStatus: "",
            memberDependents: "",
            MymemberDependents: false,
            mStatus: 'Not found',
            groupMemberStatus: "",
        }
    }
    memberdetails = [];
    componentDidMount = () => {
        this.setState({
            db: this.props.location.state.db, firstname: this.props.location.state.firstname,
            email: this.props.location.state.email, userRole: this.props.location.state.userRole
        });
        console.log(this.props.location)
        this.loadGroupMembers();
        this.getGroupMembersStatus();
    }


    componentDidUpdate() {
        window.onpopstate = e => {
            if (window.confirm('Are you sure you want to log out?')) {
                this.appLogout();
            } else {
                this.props.navigate('/registrations', {
                    state: {
                        db: this.state.db, email: this.state.email,
                        firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
                    }
                });
            }
        }
    }


    // getMemberStatus = async (mid) => {

    //     let config = {
    //         headers: { 'Accept': 'application/json' },
    //         params: {
    //             'businessname': this.state.db,
    //             'memberid': mid,

    //         }
    //     }
    //    // const url = "http://localhost/kimvuka-php/api/getMemberStatus.php";
    //     const url = "https://testmembership.bktsystems.com/api/getMemberStatus.php";
    //     const response = await axios.get(url, config);
    //     console.log(response.data);
    //     this.setState({ memberStatus: response.data[0]['status'] })
    //     if (response.data[0]['status'] === null) {
    //         this.setState({ memberStatus: 'No registration found!' })
    //     }

    // }

    getMemberDetails = async (recordid) => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "social", recordid: recordid, businessname: this.state.db }
        }
        // const url = "http://localhost/kimvuka-php/api/getMemberDetails.php";
        const url = "https://testmembership.bktsystems.com/api/getMemberDetails.php";
        const response = await axios.get(url, config);
        // console.log(response.data);
        let mstat = this.getMemberStatus(recordid)
        this.setState({ memberdetails: response.data });
        this.memberdetails = response.data;
        //console.log('ooooo'+mstat);

        this.setState({
            memberId: response.data[0]['id'], memberName: this.memberdetails[0]['name'], memberSurname: this.memberdetails[0]['surname'],
            phone: this.memberdetails[0]['phone'], email: this.memberdetails[0]['email'], address: this.memberdetails[0]['address'], memberGender: this.memberdetails[0]['gender'],
            maritalStatus: this.memberdetails[0]['family_status'], memberCity: this.memberdetails[0]['city'], memberCountry: this.memberdetails[0]['country'],
            memberDob: this.memberdetails[0]['dob'], memberJoinDate: this.memberdetails[0]['join_date'], memberStatus: mstat
        });

        // this.memberShipStatusAction(this.memberdetails[0]['status']);

        if (this.state.userRole === 'admin') {
            document.getElementById('approveDiv').style.display = 'block';
            document.getElementById('submitDetails').style.display = 'block';
            //return 'block';
        }
        else {
            document.getElementById('approveDiv').style.display = 'none';
            document.getElementById('submitDetails').style.display = 'none';
            // return 'none';
        }

        //
    }
    customDependents = "";

    getMemberDepedents = async (recordid) => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "social", recordid: recordid, businessname: this.state.db }

        }
        //  const url = "http://localhost/kimvuka-php/api/getMemberDependents.php";
        const url = "https://testmembership.bktsystems.com/api/getMemberDependents.php";
        const response = await axios.get(url, config);
        // console.log(response.data);
        if (Array.isArray(response.data)) {
            //    console.log(response.data);
            this.setState({ memberDependents: response.data });
            this.customDependents = response.data;
            //console.log(response.data);
            // return true

        }
        // else{
        //     return false
        // }

    }

    getMemberStatus = (mid) => {
        let mstatus = 'Submitted';

        for (let i = 0; i < this.state.groupMemberStatus.length; i++) {
            if (mid === this.state.groupMemberStatus[i].memberid) {
                this.mstatus = this.state.groupMemberStatus[i].status
                break;
            }
        }
        return this.mstatus;

    }

    getGroupMembersStatus = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "social", businessname: this.props.location.state.db }

        }
        // const url = "http://localhost/kimvuka-php/api/getGroupMembersStatus.php";
        const url = "https://testmembership.bktsystems.com/api/getGroupMembersStatus.php";
        const response = await axios.get(url, config);
        /// console.log(response.data);
        if (Array.isArray(response.data)) {
            this.setState({ groupMemberStatus: response.data });
        }
    }

    updateFromDetails = () => {
        this.setState({
            memberId: "", memberName: "", memberSurname: "", phone: "", email: "", address: "", memberGender: "", maritalStatus: "",
            memberCity: "", memberCountry: "", memberDob: "", memberJoinDate: "", memberStatus: ""
        });
        this.customDependents = "";
    }
    openDetails = (dataId) => {
        this.getMemberDetails(dataId);
        this.getMemberDepedents(dataId);
        // this.getUserApproveRights(this.state.userRole)
        this.setState({ details: "details", recordid: dataId, memberdetails: [] });
        //console.log(this.state.memberDependents)
        this.handleDetailsOpen.current.handleDetailsOpen();

    }

    onDetailsClose = () => {
        this.setState({ details: "", memberdetails: [] });
    }

    loadGroupMembers = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "businessname": this.props.location.state.db }

        }

        //const url = "http://localhost/kimvuka-php/api/getGroupMembers.php";
        const url = "https://testmembership.bktsystems.com/api/getGroupMembers.php";
        const response = await axios.get(url, config);
        
        if (Array.isArray(response.data)) {
            if (this.props.location.state.userRole === 'user') {
                for (let i = 0; i < response.data.length; i++) {
                
                    if (this.props.location.state.email === response.data[i].email) {
                    console.log(response.data[i])
                        this.setState({ membersData: [response.data[i]] })
                        break
                    }
                }
            } else {
                this.setState({ membersData: response.data });
            }

        }
        if (response.data === 'No data found') {
            this.setState({ membersCount: response.data })
        }

        // console.log(response.data);
    }

    appLogout = (e) => {
        // e.preventDefault();
        this.props.navigate('/', { state: { db: '', email: '', firstname: '', userRole: "" } });
        //this.props.history.push({ pathname: '/', state: { fullname: "" } })
    }

    memberShipStatusAction = (status) => {
        if (status === 'Submitted') {
            document.getElementById('approve').disabled = false;
            document.getElementById('cancel').disabled = false;
        }
        if (status === 'Approved') {
            document.getElementById('approve').checked = true;
            document.getElementById('approve').disabled = true;
            document.getElementById('cancel').disabled = false;
        }

    }
    handleRowClick = (strRowId) => {
        console.log('Clicked' + strRowId);
    }

    goToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/menu', {
            state: {
                db: this.props.location.state.db, email: this.props.location.state.email,
                firstname: this.props.location.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
            }
        });
    }

    render() {
        return (
            <div className='mainDivHome' style={{ border: '2px solid rgb(89, 100, 95)', borderRadius: "10px" }}>
                <div style={{ width: "100%" }}>
                    <span>
                        <Button style={{ paddingLeft: "5px", width: "50%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", fontSize: "18px", color: "white", fontStyle: "italic" }} onClick={this.goToMenu}>Main Menu</Button>
                        <Button style={{ paddingLeft: "5px", width: "50%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", fontSize: "18px", color: "#ff7400", fontStyle: "italic" }} text="Logout" onClick={this.appLogout}>Logout</Button>
                    </span>
                </div>
                <div style={{ paddingTop: "10px", textAlign: "center" }}>
                    <span className="businessname"><h4>{this.props.location.state.db}</h4></span>
                    <span style={{ fontStyle: "italic" }}><label>Welcome {this.props.location.state.firstname}</label></span>
                    {<span style={{ fontStyle: "italic" }}><label>, today is {this.state.date}</label></span>}

                </div>
                <div>
                    <Form>
                        <div style={{ paddingTop: "20px" }}>
                            <div style={{ paddingBottom: "10px" }}>
                                <div style={{ textAlign: "center" }}><Label> <h4>MEMBERS LIST <b>{this.state.membersCount}</b></h4></Label></div>
                            </div>
                            <table style={{ borderBottom: "1px solid white", width: "100%" }}>
                                <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white", borderLeft: "1px solid white" }}>Ref no</th>
                                <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>Full name </th>
                                <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>Date</th>
                                <th style={{ backgroundColor: "lightgray", height: "20px", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>Status</th>
                                {/* {this.state.membersData.map(function (item) { */}
                                {this.state.membersData.map((item, index) => {
                                    return (<tr style={{ height: "5px", color: "darkblue", borderBottom: "1px solid white", borderTop: "1px solid white", cursor: "pointer" }}
                                        // key={item.id} onClick={() => this.handleRowClick(item.id)}>
                                        key={item.id} onClick={() => this.openDetails(item.id)}>
                                        {/* {this.getMemberStatus(item.id)} */}
                                        <td style={{ borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white", borderLeft: "1px solid white" }}>{item.id}</td>
                                        <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>{item.name}</td>
                                        <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }}>{item.modified.substring(0,item.modified.length-9)}</td>
                                        <td style={{ borderColor: "white", borderBottom: "1px solid white", borderTop: "1px solid white", borderRight: "1px solid white" }} >{this.getMemberStatus(item.id)}</td>
                                    </tr>)
                                })}
                            </table>
                        </div>
                        <div>
                            <Details
                                ref={this.handleDetailsOpen}
                                onDetailsClose={this.onDetailsClose}
                                updateFromDetails={this.updateFromDetails}
                                MymemberDependents={this.getMemberDepedents}
                                // approverRights={this.getUserApproveRights(this.state.userRole)}
                                memberDependents={this.state.memberDependents}
                                customDependents={this.customDependents}
                                businessname={this.state.db}
                                recordid={this.state.recordid}
                                username={this.state.firstname}
                                memberId={this.state.memberId}
                                memberName={this.state.memberName}
                                memberSurName={this.state.memberSurname}
                                mobilePhone={this.state.phone}
                                email={this.state.email}
                                address={this.state.address}
                                memberGender={this.state.memberGender}
                                maritalStatus={this.state.maritalStatus}
                                memberCity={this.state.memberCity}
                                memberCountry={this.state.memberCountry}
                                memberDob={this.state.memberDob}
                                memberJoinDate={this.state.memberJoinDate}
                                membershipStatus={this.state.memberStatus}
                                userRole={this.state.userRole}
                            // memberdetails={this.state.memberdetails}
                            // loadGroupMembers={this.loadGroupMembers}
                            // getMemberDetails={this.getMemberDetails}
                            />
                        </div>

                    </Form>
                </div>
            </div>
        );
    }
}

export default withNavigateHook(Registrations);